// eslint-disable-next-line import/prefer-default-export
export const appStartTime = new Date().getTime();
